import { themeVar } from '@/styles/theme';
import styled from 'styled-components';

export const EditInvestorModalPageWrapper = styled.div`
  padding: 50px;
`;

export const EditInvestorSectionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const EditInvestorModalPageForm = styled.form`
  padding: 40px;
  border-radius: 10px;
  border: 1px solid ${themeVar('border.base')};
  background: ${themeVar('layer.1')};
`;

export const EditInvestorFormFieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  padding-top: 20px;
`;

export const EditInvestorFormDevider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${themeVar('border.base')};
`;

export const EditInvestorFormFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin: 50px 0 10px 0;
`;

export const EditInvestorPreviewFields = styled.div`
  padding: 20px;
`;

export const EditInvestorPreviewFieldItem = styled.div<{ isMobile: boolean }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  width: ${({ isMobile }) => (isMobile ? '100%' : '50%')};
  padding: 2px 10px;
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
  color: ${themeVar('font.base')};
`;

export const EditInvestorPreviewFieldTitle = styled.div`
  padding: 4px;
`;

export const EditInvestorPreviewFieldValue = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 4px;
  font-weight: 600;
`;
